import styled from "@emotion/styled";
import bgImage from "../../assets/bgImage.png";

const LeaveSummaryStyle = styled.div({
  position: "relative",
  background: `url(${bgImage})`,
  objectFit: "cover",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  backgroundPosition: "center center",

  "& .ant-table-pagination.ant-pagination": {
    display: "none",
  },
});

export default LeaveSummaryStyle;
